export default [

     {
          path: '/lms-user-answer',
          name: 'LmsUserAnswer',
          component: () => import("@/views/Page/LmsUserAnswer/LmsUserAnswer.vue"),
           meta: {
               title: 'Lms User Answer',
          },
     }
];